import { render } from "./CardStyleSettings.vue?vue&type=template&id=2be3dc30&scoped=true"
import script from "./CardStyleSettings.vue?vue&type=script&lang=js"
export * from "./CardStyleSettings.vue?vue&type=script&lang=js"

import "./CardStyleSettings.vue?vue&type=style&index=0&id=2be3dc30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be3dc30"]])

export default __exports__